import { Tooltip } from "@mui/material";
import React from "react";

import DownArrow from "../../../../styles/svg/date-range.svg";
import DateRange from "./DateRange";
import { TooltipName } from "../../../../utils/Enums";
import CustomMenu from "../../../../components/Menu";
import "../../../myTask/myTask.scss";
import { CustomButton } from "../../../../components/Button/Button";
import { useSelectDatePickerState } from "../../hooks/useSelectDatePickerState";

function SelectDatePicker() {
  const {
    open,
    anchorEl,
    heading,
    selectedDateLabel,
    customStaticRanges,
    handleSelectedLabel,
    handleOpen,
    handleClose,
  } = useSelectDatePickerState();

  return (
    <>
      <Tooltip title={TooltipName.WORKLOG.FILTER_BY_DATE}>
        <CustomButton
          variant="outlined"
          color="primary"
          id="epics-board-dropdown"
          aria-haspopup="true"
          onClick={handleOpen}
          startIcon={<img src={DownArrow} alt="date range" />}
          className="white-button date-filter-button mobile-filter-date-button">
          <p className="header-action-button-text mr-1">
            {selectedDateLabel === "" || selectedDateLabel === undefined
              ? heading
              : selectedDateLabel}
          </p>
        </CustomButton>
      </Tooltip>
      <CustomMenu
        id="user-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className="date-filter">
        <DateRange
          onClose={handleClose}
          handleSelectedLabel={handleSelectedLabel}
          customStaticRanges={customStaticRanges}
        />
      </CustomMenu>
    </>
  );
}
export default SelectDatePicker;
